import { h } from './pragma.mjs';

export default (aktivni) => {
    return (
      <gov-tabs-item label="Můj katastr" id="katastr" default={aktivni}>
        <h1>Můj katastr</h1>

        <section id="mujkatastrchipzone">
          {/*<gov-chip type="outlined" href="https://ozs.cuzk.cz/OzsWAEWEB/uvod/uvod.do" icon-left="basic/eye" icon-right="basic/check-circle-fill" variant="success" size="m" tag="a">Služba sledování změn: Aktivní</gov-chip>*/}

          {/*<gov-chip type="outlined" href="https://ozs.cuzk.cz/OzsWAEWEB/uvod/uvod.do" icon-left="basic/eye" icon-right="basic/gear-fill" variant="warning" size="m" tag="a">Služba sledování změn: Ne</gov-chip>*/}
        </section>

        <section>
          <h2>Moje řízení</h2>
          <input type="checkbox" id="ukoncenaRizeniChk" />
          <label for="ukoncenaRizeniChk">Zobrazit ukončená řízení</label>
          <div id="moje-rizeni-accordion-active"></div>
        </section>
        <section>
          <h2>Nemovitosti, které vlastním nebo spoluvlastním</h2>

          <div class="table-frame">
            <table class="vdp-tabulka">
              <tbody id="nemovitostiMujPortalTable">
                <tr>
                  <th>Katastrální území</th>
                  <th>Nemovitost</th>
                  <th>Podíl</th>
                  <th>Číslo LV</th>
                  <th>Zatížení</th>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section>
          <h2>Oprávnění k cizím nemovitostem</h2>

          <div class="table-frame">
            <table class="vdp-tabulka">
              <tbody id="jpvProMujPortalTable">
                <tr>
                  <th style="width:30%">Právo</th>
                  <th style="width:20%">Katastrální území</th>
                  <th style="width:30%">Nemovitost</th>
                  <th style="text-align: right;width:10%">Číslo LV</th>
                  <th style="text-align: right;width:10%"></th>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
        <section>
          <h2>Další zápisy u mých nemovitostí</h2>

          <div class="table-frame">
            <table class="vdp-tabulka">
              <tbody id="dalsiZapisyMujPortalTable">
                <tr>
                  <th style="width:30%">Zápis</th>
                  <th style="width:20%">Katastrální území</th>
                  <th style="width:30%">Nemovitost</th>
                  <th style="text-align: right;width:10%">Číslo LV</th>
                  <th style="text-align: right;width:10%">Podíl</th>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </gov-tabs-item>
    );
}